import React from 'react';
import Routers from './router/Routers';
import './style.css';

function App() {
  return <Routers />;
}

export default App;
